import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError, change } from 'redux-form';
import { convertUtcDate, toFromDates } from '../components/Common/cleanDates';

import {
    REQUEST_PURCHASE_RETURNS,
    FETCH_PURCHASE_RETURNS_SUCCESS,
    FETCH_PURCHASE_RETURNS_FAILURE,
    SELECT_PURCHASE_RETURN,
    SELECT_VENDOR,
    RESET_CURRENT_PURCHASE_RETURN,
    REQUEST_PURCHASE_RETURN_DETAIL,
    FETCH_PURCHASE_RETURN_DETAIL_SUCCESS,
    FETCH_PURCHASE_RETURN_DETAIL_FAILURE,
    REQUEST_CREATING_PURCHASE_RETURN,
    CREATE_PURCHASE_RETURN_SUCCESS,
    CREATE_PURCHASE_RETURN_FAILURE,
    REQUEST_EDITING_PURCHASE_RETURN,
    EDIT_PURCHASE_RETURN_SUCCESS,
    EDIT_PURCHASE_RETURN_FAILURE,
    COMPLETE_PURCHASE_RETURN,
    COMPLETE_PURCHASE_RETURN_SUCCESS,
    COMPLETE_PURCHASE_RETURN_FAILURE,
    REQUEST_VOID_PURCHASE_RETURN,
    VOID_PURCHASE_RETURN_SUCCESS,
    VOID_PURCHASE_RETURN_FAILURE,
    REQUEST_SYNC_QB_PDF,
    FETCH_SYNC_QB_PDF_SUCCESS,
    FETCH_SYNC_QB_PDF_FAILURE,
} from './type'

import {
  MFG_PURCHASE_RETURN_APPROVAL_URL,
  MFG_PURCHASE_RETURN_REVIEW_URL,
  MFG_PURCHASE_RETURNS_URL,
  PURCHASE_RETURNS_URL,
  PURCHASE_URL,
} from './url';
import {
  ROOT_URL,
  isGGI, isVAK,
} from './root_url';

import { DEFAULT_ERROR } from '../components/Common/constants';

const form = 'purchaseReturnForm';

export function fetchPurchaseReturns(FromDate, ToDate, days, Status, callBack = ()=> {}) {
    const dates = toFromDates(days, FromDate, ToDate);
    const fromDate = `?PostingDate__gte=${dates.fromDate}`;
    const toDate = `&PostingDate__lte=${dates.toDate}`;
    const status = (Status && Status !== 'all') ?  `&ReturnStatus=${Status}` : '';
    return (dispatch, getState) => {
      const selectedWarehouse = JSON.parse(localStorage.getItem('selectedWarehouse'));
      if (!selectedWarehouse) return;
        const Pickup_Warehouse_id_id = `&Pickup_Warehouse_id_id=${selectedWarehouse.value}`
        dispatch(requestPurchaseReturns());
        return axios.get(PURCHASE_RETURNS_URL  + fromDate + toDate + status + Pickup_Warehouse_id_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              callBack(response);
              dispatch(fetchPurchaseReturnsSuccess(response))
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchPurchaseReturnsFailure(err));
              }
            });
    }
}

export const changeFormValue = (name, value) => (dispatch) => {
  dispatch(change(form, name, value));
};

export function requestPurchaseReturns() {
    return {
        type: REQUEST_PURCHASE_RETURNS,
    };
}

export function fetchPurchaseReturnsSuccess(purchaseReturns) {
    return {
        type: FETCH_PURCHASE_RETURNS_SUCCESS,
        payload: purchaseReturns
    };
}

export function fetchPurchaseReturnsFailure(error) {
    return {
        type: FETCH_PURCHASE_RETURNS_FAILURE,
        payload: error
    };
}


export function selectPurchaseReturn(purchaseReturn) {
    return {
        type: SELECT_PURCHASE_RETURN,
        payload: purchaseReturn
    };
}

export function selectVendor(vendor) {
    return {
        type: SELECT_VENDOR,
        payload: vendor
    };
}

export function resetCurrentPurchaseReturn() {
    return {
        type: RESET_CURRENT_PURCHASE_RETURN
    }
}

// Fetch the detail page.

export function fetchPurchaseReturnDetail(pr_id, prc_id) {
    return dispatch => {
        dispatch(requestPurchaseReturnDetail());
        if(prc_id) {
          return axios.get(PURCHASE_RETURNS_URL + 'completed/' + prc_id,
              {
                  headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
              }
          )
              .then(response => {
                dispatch(fetchPurchaseReturnDetailSuccess(response));
              }, err => {
                if (err.status === 500 || err.status === 404) {
                  err.data = DEFAULT_ERROR;
                }
                if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                  document.getElementById('tokenInvalid').style.display = 'flex'
                } else {
                  dispatch(fetchPurchaseReturnDetailFailure(err));
                }
              });
        }
        else {
          return axios.get(PURCHASE_RETURNS_URL + pr_id,
              {
                  headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
              }
          )
              .then(response => {
                dispatch(fetchPurchaseReturnDetailSuccess(response));
              }, err => {
                if (err.status === 500 || err.status === 404) {
                  err.data = DEFAULT_ERROR;
                }
                if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                  document.getElementById('tokenInvalid').style.display = 'flex'
                } else {
                  dispatch(fetchPurchaseReturnDetailFailure(err));
                }
              });
        }
    }
}

export function requestPurchaseReturnDetail() {
    return {
        type: REQUEST_PURCHASE_RETURN_DETAIL,
    };
}

export function fetchPurchaseReturnDetailSuccess(purchaseReturnDetail) {
    purchaseReturnDetail = purchaseReturnDetail.data;
    if(purchaseReturnDetail.ReturnDate) purchaseReturnDetail.ReturnDate = convertUtcDate(purchaseReturnDetail.ReturnDate);
    return {
        type: FETCH_PURCHASE_RETURN_DETAIL_SUCCESS,
        payload: purchaseReturnDetail
    };
}

// export function fetchPurchaseReturnCompletedDetail(pr_id) {
//     return dispatch => {
//         dispatch(requestPurchaseReturnCompletedDetail());
//         return axios.get(PURCHASE_RETURNS_URL + pr_id,
//             {
//                 headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
//             }
//         )
//             .then(response => {
//                 dispatch(fetchPurchaseReturnCompletedDetailSuccess(response));
//             })
//             .catch(response => {
//                 dispatch(fetchPurchaseReturnCompletedDetailFailure(response));
//             })
//     }
// }
//
// export function requestPurchaseReturnCompletedDetail() {
//     return {
//         type: REQUEST_PURCHASE_RETURN_DETAIL,
//     };
// }
//
// export function fetchPurchaseReturnCompletedDetailSuccess(purchaseReturnDetail) {
//     purchaseReturnDetail = purchaseReturnDetail.data;
//     if(purchaseReturnDetail.ReturnDate) purchaseReturnDetail.ReturnDate = new Date(purchaseReturnDetail.ReturnDate);
//     return {
//         type: FETCH_PURCHASE_RETURN_DETAIL_SUCCESS,
//         payload: purchaseReturnDetail
//     };
// }

export function fetchPurchaseReturnDetailFailure(error) {
    return {
        type: FETCH_PURCHASE_RETURN_DETAIL_FAILURE,
        payload: error
    };
}

export function createPurchaseReturn({
  PostingDate,
  ReturnReason,
  FinalNetWeight,
  FinalShippingWeight,
  TotalPrice,
  NoteToVendor,
  ReleaseInformation,
  CarryType,
  Discount,
  ShippingCost,
  HandlingCost,
  Adjustment,
  PurchaseStatus,
  MiscCost,
  MiscNote,
  TaxRate,
  PaymentStatus,
  FinalPrice,
  Vendor_id,
  Deliver_VendorDetail_id,
  Pickup_Warehouse_id,
  DispatchMethod_id,
  DispatchOutSourceContact_id,
  Purchaser_User_id,
  Modifier_User_id,
  PaymentTerm_id,
  ShippingMethod,
  MemoNum,
  Review_User_id,
  Approve_User_id,
}, Purchase_Return_Line, isPurchaseCredit, isMFGRedeliver = false) {
    // Purchase_Return_Line.map(
    //     product => {
    //         // product.WarehouseBin_id = product.WarehouseBin_id.WarehouseBin_id || product.WarehouseBin_id;
    //         // product.WarehouseZone_id = product.WarehouseZone_id.WarehouseZone_id || product.WarehouseZone_id;
    //         if (product.Product_id)
    //             product.Product_id = product.Product_id.value || product.Product_id;
    //     }
    // )
    if (PostingDate) PostingDate = convertUtcDate(PostingDate);
    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
    if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
    if (Deliver_VendorDetail_id) Deliver_VendorDetail_id = Deliver_VendorDetail_id.value || Deliver_VendorDetail_id;
    if (CarryType) CarryType = CarryType.value || CarryType;
    if (ReturnReason) ReturnReason = ReturnReason.value || ReturnReason;
    if (Pickup_Warehouse_id) Pickup_Warehouse_id = Pickup_Warehouse_id.value || Pickup_Warehouse_id;
    if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
    if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
    if (Review_User_id) Review_User_id = Review_User_id.value || Review_User_id;
    if (Approve_User_id) Approve_User_id = Approve_User_id.value || Approve_User_id;
    return dispatch => {
        dispatch({ type: REQUEST_CREATING_PURCHASE_RETURN });
        return axios.post(PURCHASE_RETURNS_URL,
            {
                Purchase_Return_Line,
                PostingDate,
                ReturnReason,
                TotalPrice,
                NoteToVendor,
                ReleaseInformation,
                CarryType,
                Discount,
                ShippingCost,
                HandlingCost,
                Adjustment,
                PurchaseStatus,
                MiscCost,
                MiscNote,
                TaxRate,
                PaymentStatus,
                FinalPrice,
                Vendor_id,
                Deliver_VendorDetail_id,
                Pickup_Warehouse_id,
                DispatchMethod_id,
                DispatchOutSourceContact_id,
                Purchaser_User_id,
                Modifier_User_id,
                PaymentTerm_id,
                ShippingMethod,
                MemoNum,
                IsPurchaseCredit: isPurchaseCredit,
                IsPurchaseRedeliver: isMFGRedeliver,
                Review_User_id,
                Approve_User_id,
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
        .then(response => {
          dispatch(createPurchaseReturnSuccess());
          if (!isVAK) {
            browserHistory.push('/purchaseReturn');
          } else {
            dispatch(fetchPurchaseReturnDetail(response.data.PurchaseReturn_id, response.data.Return_PurchaseCompleted_id));
          }
        }, err => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          } else {
            dispatch(createPurchaseReturnFailure(err));
          }
        });
    }
}

export function createPurchaseReturnSuccess() {
    return {
        type: CREATE_PURCHASE_RETURN_SUCCESS
    }
}

export function createPurchaseReturnFailure(error) {
    return {
        type: CREATE_PURCHASE_RETURN_FAILURE,
        payload: error
    }
}

export function editPurchaseReturn({
    PurchaseReturnCompleted_id,
    PurchaseReturn_id,
    PostingDate,
    ReturnReason,
    FinalNetWeight,
    FinalShippingWeight,
    TotalPrice,
    NoteToVendor,
    ReleaseInformation,
    CarryType,
    Discount,
    ShippingCost,
    HandlingCost,
    Adjustment,
    PurchaseStatus,
    MiscCost,
    MiscNote,
    TaxRate,
    PaymentStatus,
    FinalPrice,
    Vendor_id,
    Deliver_VendorDetail_id,
    Pickup_Warehouse_id,
    DispatchMethod_id,
    DispatchOutSourceContact_id,
    Purchaser_User_id,
    Modifier_User_id,
    PaymentTerm_id,
    ShippingMethod,
    MemoNum,
    Review_User_id,
    Approve_User_id,
}, Purchase_Return_Line) {
    FinalShippingWeight = 0;
    Purchase_Return_Line.map(
        product => {
            if(product.WarehouseBin_id) product.WarehouseBin_id = product.WarehouseBin_id.WarehouseBin_id || product.WarehouseBin_id;
            if(product.WarehouseZone_id) product.WarehouseZone_id = product.WarehouseZone_id.WarehouseZone_id || product.WarehouseZone_id;
            if (product.Product_id)
                product.Product_id = product.Product_id.value || product.Product_id;
        }
    )
    if (PostingDate) PostingDate = convertUtcDate(PostingDate);
    if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
    if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
    if (Deliver_VendorDetail_id) Deliver_VendorDetail_id = Deliver_VendorDetail_id.value || Deliver_VendorDetail_id;
    if (CarryType) CarryType = CarryType.value || CarryType;
    if (ReturnReason) ReturnReason = ReturnReason.value || ReturnReason;
    if (Pickup_Warehouse_id) Pickup_Warehouse_id = Pickup_Warehouse_id.value || Pickup_Warehouse_id;
    if(PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
    if (Review_User_id) Review_User_id = Review_User_id.value || Review_User_id;
    if (Approve_User_id) Approve_User_id = Approve_User_id.value || Approve_User_id;
    if(PurchaseReturnCompleted_id) {
      let Purchase_Return_Line_Completed = Purchase_Return_Line;
      return dispatch => {
          dispatch({ type: REQUEST_EDITING_PURCHASE_RETURN });
          axios.put((PURCHASE_RETURNS_URL + 'completed/' + PurchaseReturnCompleted_id),
              {
                  Purchase_Return_Line_Completed,
                  PostingDate,
                  ReturnReason,
                  FinalNetWeight,
                  FinalShippingWeight,
                  TotalPrice,
                  NoteToVendor,
                  ReleaseInformation,
                  CarryType,
                  Discount,
                  ShippingCost,
                  HandlingCost,
                  Adjustment,
                  PurchaseStatus,
                  MiscCost,
                  MiscNote,
                  TaxRate,
                  PaymentStatus,
                  FinalPrice,
                  Vendor_id,
                  Deliver_VendorDetail_id,
                  Pickup_Warehouse_id,
                  DispatchMethod_id,
                  DispatchOutSourceContact_id,
                  Purchaser_User_id,
                  Modifier_User_id,
                  PaymentTerm_id,
                  MemoNum,
                  Review_User_id,
                  Approve_User_id,
              },
              {
                  headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
              }
          )
              .then(response => {
                dispatch(editPurchaseReturnSuccess());
                if (!isVAK) {
                  browserHistory.push('/purchaseReturn'); // If editd succesfully, refresh the paymentTerm page.
                }
              }, err => {
                if (err.status === 500 || err.status === 404) {
                  err.data = DEFAULT_ERROR;
                }
                if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                  document.getElementById('tokenInvalid').style.display = 'flex'
                } else {
                  dispatch(editPurchaseReturnFailure(err));
                }
              });
      }
    }
    else {
      return dispatch => {
          dispatch({ type: REQUEST_EDITING_PURCHASE_RETURN });
          axios.put((PURCHASE_RETURNS_URL + PurchaseReturn_id),
              {
                  Purchase_Return_Line,
                  PostingDate,
                  ReturnReason,
                  FinalNetWeight,
                  FinalShippingWeight,
                  TotalPrice,
                  NoteToVendor,
                  ReleaseInformation,
                  CarryType,
                  Discount,
                  ShippingCost,
                  HandlingCost,
                  Adjustment,
                  PurchaseStatus,
                  MiscCost,
                  MiscNote,
                  TaxRate,
                  PaymentStatus,
                  FinalPrice,
                  Vendor_id,
                  Deliver_VendorDetail_id,
                  Pickup_Warehouse_id,
                  DispatchMethod_id,
                  DispatchOutSourceContact_id,
                  Purchaser_User_id,
                  Modifier_User_id,
                  PaymentTerm_id,
                  MemoNum,
                  Review_User_id,
                  Approve_User_id,
              },
              {
                  headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
              }
          )
              .then(response => {
                dispatch(editPurchaseReturnSuccess());
                if (!isVAK) {
                  browserHistory.push('/purchaseReturn'); // If editd succesfully, refresh the paymentTerm page.
                }
              }, err => {
                if (err.status === 500 || err.status === 404) {
                  err.data = DEFAULT_ERROR;
                }
                if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                  document.getElementById('tokenInvalid').style.display = 'flex'
                } else {
                  dispatch(editPurchaseReturnFailure(err));
                }
              });
      }
    }
}

export function editPurchaseReturnSuccess() {
    return {
        type: EDIT_PURCHASE_RETURN_SUCCESS
    }
}

export function editPurchaseReturnFailure(error) {
    return {
        type: EDIT_PURCHASE_RETURN_FAILURE,
        payload: error
    }
}

export function completePurchaseReturn(pr_id) {
  return dispatch => {
      dispatch({type: COMPLETE_PURCHASE_RETURN});
      return axios.get(PURCHASE_RETURNS_URL + 'open/' + pr_id,
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(completePurchaseReturnSuccess());
            browserHistory.push('/purchaseReturn');
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
              document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
              dispatch(completePurchaseReturnFailure(err));
            }
          });
  }
}

export function completePurchaseReturnSuccess() {
    return {
        type: COMPLETE_PURCHASE_RETURN_SUCCESS
    }
}

export function completePurchaseReturnFailure(response) {
    return {
        type: COMPLETE_PURCHASE_RETURN_FAILURE,
        payload: response
    }
}


function voidPurchaseReturnSuccess() {
  return {
    type: VOID_PURCHASE_RETURN_SUCCESS,
  };
}

function voidPurchaseReturnFailure(error) {
  return {
    type: VOID_PURCHASE_RETURN_FAILURE,
    payload: error,
  };
}

export function voidPurchaseReturn(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_VOID_PURCHASE_RETURN });
    const token = localStorage.getItem('token');
    return axios({
      method: 'delete',
      url: `${PURCHASE_RETURNS_URL}${id}`,
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      dispatch(voidPurchaseReturnSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(voidPurchaseReturnFailure(err));
      }
    });
  };
}

export const finalizeSelectedReturns = (ids, success, failed) => dispatch => {
  const token = localStorage.getItem('token');
  axios({
    method: 'PUT',
    url: `${PURCHASE_URL}purchase_return_finalized/${ids}`,
    data: ids,
    headers: {
      Authorization: `Bearer ${token}`,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  })
  .then(res => {
    success();
  })
  .catch(err => {
    failed();
  })
}

export const syncPurchaseReturnToQB = (receive_ids) => dispatch => {
  const token = localStorage.getItem('token');
  const url = `${ROOT_URL}v1/quickbook/sync_purchase_return_quickbook?receive_ids=${receive_ids}`;
  dispatch({ type: REQUEST_SYNC_QB_PDF });
  axios({
    method: 'POST',
    url,
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    dispatch({ type: FETCH_SYNC_QB_PDF_SUCCESS });
    alert('Success');
  }, (err) => {
    const message = err.data || err;
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      alert(JSON.stringify(message));
    }
    dispatch({ type: FETCH_SYNC_QB_PDF_FAILURE });
  });
}
export const setReview = (id, reviewUserId, status, callback = () => {}) => {
  const token = localStorage.getItem('token');
  const data = { Review_Status: status }
  if (reviewUserId) {
    data.Review_User_id = reviewUserId;
  }
  axios.put(
    `${MFG_PURCHASE_RETURN_REVIEW_URL}${id}`,
   data,
    {
      params: {Module: 'return'},
      headers: {Authorization: `Bearer ${token}`}
    }
  ).then(response => {
    if (response.status !== 200) {
      alert(response.data)
      return;
    }
    callback(response.data);
  })
}

export const setApproval = (id, status, callback = () => {}) => {
  const token = localStorage.getItem('token');
  axios.put(
    `${MFG_PURCHASE_RETURN_APPROVAL_URL}${id}`,
    {
      Approve_Status: status,
    },
    {
      headers: {Authorization: `Bearer ${token}`}
    }
  ).then(response => {
    if (response.status !== 200) {
      alert(response.data)
    }
    callback();
  })
}



// WEBPACK FOOTER //
// ./master/jsx/actions/purchaseReturns_actions.js